module.exports = __webpack_public_path__ + "fonts/CircularStd-Medium.7a92b9df.woff2";